var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1231 23.0001H7.37685C5.51143 23.0001 4 21.502 4 19.6531V4.34941C4 2.5005 5.51143 1.00244 7.37685 1.00244H15.8423L20.5 5.63972V19.6531C20.5 21.502 18.9886 23.0001 17.1231 23.0001Z",
    fill: "#596C89"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5 5.63972H16.7994C16.2755 5.63972 15.8493 5.21962 15.8493 4.70026L15.8423 1.00244",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9975 1H10.9146V2.07334H11.9975V1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 2.07349H11.9951V3.14683H13.078V2.07349Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9975 3.14673H10.9146V4.22006H11.9975V3.14673Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 4.21997H11.9951V5.29331H13.078V4.21997Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9975 5.29102H10.9146V6.36435H11.9975V5.29102Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 6.3645H11.9951V7.43784H13.078V6.3645Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9975 7.43774H10.9146V8.51108H11.9975V7.43774Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 8.51099H11.9951V9.58432H13.078V8.51099Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9975 9.58203H10.9146V10.6554H11.9975V9.58203Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.078 10.6555H11.9951V11.7289H13.078V10.6555Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0804 11.7288H10.9146V14.7203H13.0804V11.7288Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5375 13.2246H11.4546V14.2979H12.5375V13.2246Z",
    fill: "#A1BEDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZip);
export default __webpack_public_path__ + "static/media/zip.0f74f21dbe6042fb9b21f077753e71fb.svg";
export { ForwardRef as ReactComponent };